import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'campaign-tracker.field-1-name': {
    id: 'campaign-tracker.field-1-name',
    defaultMessage: 'Campaign name',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Campaign name',
  },
  'campaign-tracker.field-2-name': {
    id: 'campaign-tracker.field-2-name',
    defaultMessage: 'Season',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Season',
  },
  'campaign-tracker.field-2-select-option-1': {
    id: 'campaign-tracker.field-2-select-option-1',
    defaultMessage: 'Summer campaign',
    description:
      'The option value for option #1 in field #2 for this database template. In this case: Summer campaign',
  },
  'campaign-tracker.field-2-select-option-2': {
    id: 'campaign-tracker.field-2-select-option-2',
    defaultMessage: 'Autumn campaign',
    description:
      'The option value for option #2 in field #2 for this database template. In this case: Autumn campaign',
  },
  'campaign-tracker.field-2-select-option-3': {
    id: 'campaign-tracker.field-2-select-option-3',
    defaultMessage: 'Winter campaign',
    description:
      'The option value for option #3 in field #2 for this database template. In this case: Winter campaign',
  },
  'campaign-tracker.field-2-select-option-4': {
    id: 'campaign-tracker.field-2-select-option-4',
    defaultMessage: 'Spring campaign',
    description:
      'The option value for option #4 in field #2 for this database template. In this case: Spring campaign',
  },
  'campaign-tracker.field-3-name': {
    id: 'campaign-tracker.field-3-name',
    defaultMessage: 'Release date',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Release date',
  },
  'campaign-tracker.field-4-name': {
    id: 'campaign-tracker.field-4-name',
    defaultMessage: 'Links',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Links',
  },
  'campaign-tracker.field-5-name': {
    id: 'campaign-tracker.field-5-name',
    defaultMessage: 'Status',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Status',
  },
  'campaign-tracker.field-5-select-option-1': {
    id: 'campaign-tracker.field-5-select-option-1',
    defaultMessage: 'Planning',
    description:
      'The option value for option #1 in field #5 for this database template. In this case: Planning',
  },
  'campaign-tracker.field-5-select-option-2': {
    id: 'campaign-tracker.field-5-select-option-2',
    defaultMessage: 'In Progress',
    description:
      'The option value for option #2 in field #5 for this database template. In this case: In Progress',
  },
  'campaign-tracker.field-5-select-option-3': {
    id: 'campaign-tracker.field-5-select-option-3',
    defaultMessage: 'Delayed',
    description:
      'The option value for option #3 in field #5 for this database template. In this case: Delayed',
  },
  'campaign-tracker.field-5-select-option-4': {
    id: 'campaign-tracker.field-5-select-option-4',
    defaultMessage: 'Done',
    description:
      'The option value for option #4 in field #5 for this database template. In this case: Done',
  },
  'campaign-tracker.view-1-name': {
    id: 'campaign-tracker.view-1-name',
    defaultMessage: 'All campaigns',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All campaigns',
  },
  'campaign-tracker.entry-1-cell-5': {
    id: 'campaign-tracker.entry-1-cell-5',
    defaultMessage: 'Marketing campaign',
    description:
      'The text value of cell #5 in row (entry) #1 in this database template. In this case:  Marketing campaign',
  },
  'campaign-tracker.entry-2-cell-5': {
    id: 'campaign-tracker.entry-2-cell-5',
    defaultMessage: 'Confluence feature release',
    description:
      'The text value of cell #5 in row (entry) #2 in this database template. In this case:  Confluence feature release',
  },
  'campaign-tracker.entry-3-cell-5': {
    id: 'campaign-tracker.entry-3-cell-5',
    defaultMessage: 'Email campaign',
    description:
      'The text value of cell #5 in row (entry) #3 in this database template. In this case:  Email campaign',
  },
  'campaign-tracker.entry-4-cell-1': {
    id: 'campaign-tracker.entry-4-cell-1',
    defaultMessage: 'Brand awareness launch',
    description:
      'The text value of cell #1 in row (entry) #4 in this database template. In this case:  Brand awareness launch',
  },
  'campaign-tracker.entry-5-cell-1': {
    id: 'campaign-tracker.entry-5-cell-1',
    defaultMessage: 'Customer retention drive',
    description:
      'The text value of cell #1 in row (entry) #5 in this database template. In this case:  Customer retention drive',
  },
});
